import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { formatAddress } from '@/modules/expense-reports/lib/address';
import { CopyAnimatedIcon, CopyButton, CopyTrigger } from '@/modules/shared/components/copy-button';
import { Identicon } from '@/modules/shared/components/identicon';
interface WalletInfoProps {
  name: string;
  address: string;
}
function WalletInfo(t0) {
  const $ = _c(21);
  const {
    name,
    address
  } = t0;
  const t1 = address || name;
  let t2;
  if ($[0] !== t1) {
    t2 = <Identicon value={t1} className="size-6 min-w-6 md:size-8 md:min-w-8" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== name) {
    t3 = <div className="flex"><div className="text-xs/4.5 font-medium md:text-sm/5.5 md:font-semibold">{name}</div></div>;
    $[2] = name;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `https://etherscan.io/address/${address}`;
  let t5;
  if ($[4] !== address) {
    t5 = formatAddress(address);
    $[4] = address;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <Link href={t4} target="_blank" className="text-status-progress text-xs/4.5 font-medium hover:opacity-80">{t5}</Link>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CopyTrigger><CopyAnimatedIcon className="size-4" /></CopyTrigger>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== address) {
    t8 = <CopyButton value={address}>{t7}</CopyButton>;
    $[10] = address;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8) {
    t9 = <div className="flex gap-4">{t6}{t8}</div>;
    $[12] = t6;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t3 || $[16] !== t9) {
    t10 = <div>{t3}{t9}</div>;
    $[15] = t3;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t2) {
    t11 = <div className="flex items-center gap-2">{t2}{t10}</div>;
    $[18] = t10;
    $[19] = t2;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
export { WalletInfo };